import { Box, Text } from '@jfs/ui-new';
import { Icon } from '@jfs/ui-new/src/comps/IconNew';
import { ViewStyle } from 'react-native';

interface IconWithTextProps {
  containerStyle?: ViewStyle;
}

export const IconWithText = ({ containerStyle }: IconWithTextProps) => {
  return (
    <Box
      flexDirection={'row'}
      justifyContent={'space-between'}
      // p={16}
      // backgroundColor={'WHITE'}
      // borderRadius={8}
      // shadowColor={'BLACK'}
      shadowOpacity={0.1}
      // shadowRadius={4}
      // width={100}
      // gap={45}
      style={containerStyle}
    >
      {/* Item 1 */}
      <Box flexDirection={'column'} alignItems={'center'} flex={1}>
        <Icon id="TIMER" size={24} color={'BRAND_PRIMARY_GREEN'} />
        <Box mt={8}>
          <Text fontSize={12} textAlign='center'>Instant Onboarding</Text>
        </Box>
      </Box>

      {/* Item 2 */}
      <Box flexDirection={'column'} alignItems={'center'} flex={1}>
        <Icon id="WALLET" size={24} color={'BRAND_PRIMARY_RED'} />
        <Box mt={8}>
          <Text fontSize={12} textAlign='center'>No Additional Charges</Text>
        </Box>
      </Box>

      {/* Item 3 */}
      <Box flexDirection={'column'} alignItems={'center'} flex={1}>
        <Icon id="TICKMARK" size={24} color={'BRAND_PRIMARY_BG'} />
        <Box mt={8}>
          <Text fontSize={12} textAlign='center'>Trusted by NPCI</Text>
        </Box>
      </Box>
    </Box>
  );
};